import { View } from 'react-native'
import Toast from 'react-native-toast-message'
import { usePersonalStore } from '../../../stores/personalInfo'
import { useInitializeStore } from '../../../stores/initialize'
import { useFormsStore } from '../../../stores/onboarding'
import { globalStyles } from '../../../static/styles/global'
import HomeDetailsHeader from '../../home/HomeDetailsHeader'
import SignatureFormView from '../SignatureFormView'


const NmInformationOnline = ({ navigation, route }) => {
  const {
    mostRecentUserOnBoardings: userId,
    essUserOnBoardingKey,
    essUserOnBoardingFormKey,
    values,
  } = route.params
  const personalstore = usePersonalStore()
  const intializeStore = useInitializeStore()
  const { loading, postnmonline } = useFormsStore()




  const handlesubmit = async (signatureDataURL: string) => {
    const data = {
      entityId: personalstore?.personalData?.entityId,
      essUserKey: intializeStore?.initializeData?.userkey,
      essObKey: userId,
      essUserOnBoardingFormKey: essUserOnBoardingFormKey,
      completeOnline: true,
      maritalStatus: values?.maritalstatus,
      multipleJobs: values?.multiplejobs,
      otherDependents: values?.otherdependents,
      otherIncome: values?.otherIncome,
      deductions: values?.deductions,
      extraWithholding: values?.extraWithholdingPerPay?values?.extraWithholdingPerPay:null,
      sign: signatureDataURL,
      childTaxCreditUnder17: values?.ChildTaxCredit_Under17,
      otherDependentCredit: values?.OtherDependentCredit,
      ExemptWithholding: values?.claimExemption?.toString()
    }
    const response: any = await postnmonline(data)
    if (response?.success === true) {
      await Toast.show({
        type: 'success',
        position: 'bottom',
        text1: response?.message,
        visibilityTime: 3000,
        autoHide: true,
        topOffset: 60,
        onHide: () => {
          navigation.replace('OnboardingForms')
        }
      })
    } else {
      await Toast.show({
        type: 'error',
        position: 'bottom',
        text1: response?.message,
        visibilityTime: 3000,
        autoHide: true,
        topOffset: 60
      })
    }
  }

  return (
    // <>
    //   <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
    //     <View style={[globalStyles.horizontalPadGap]}>
    //       <HomeDetailsHeader
    //         navLabel={'Forms'}
    //         navScreen="OnboardingForms"
    //         title={'NM Withholding Taxation'}
    //         essFormKey={essFormKey}
    //       />
    //     </View>
    //   </View>
    //   <ScrollView
    //     bounces={false}
    //     showsVerticalScrollIndicator={false}
    //     contentContainerStyle={{}}

    //   >
    //     <Card
    //       style={{
    //         fontFamily: 'Arial, sans-serif',
    //         fontSize: '11px',
    //         padding: 0,
    //         margin: 0,
    //         overflow: 'hidden',
    //       }}
    //     >
    //       <View
    //         style={{ width: '100%' }}
    //         onLayout={handleContainerLayout}
    //       >
    //         {imageHeight > 0 ? (
    //           <>
    //             <Image
    //               source={{ uri: imageUri }}
    //               style={{
    //                 width: containerWidth,
    //                 height: imageHeight,
    //               }}
    //               resizeMode="contain"
    //             />

    //             <View style={{ width: 350, height: 150, margin: 15, marginBottom: 80 }}>
    //               <Text style={{ padding: 2, marginLeft: 10 }}>
    //                 {'Signature Of Employee:'}{' '}
    //               </Text>
    //               <Canvas
    //                 setSignatureDataURL={setSignatureDataURL}
    //                 setHasDrawn={setHasDrawn}
    //                 hasDrawn={hasDrawn}
    //               />
    //             </View>

    //           </>
    //         ) : (
    //           <ActivityIndicator style={{ marginVertical: 40 }} />
    //         )}
    //       </View>

    //     </Card>

    //     {loading ? (
    //       <ActivityIndicator style={{ marginTop: 20 }} />
    //     ) : (
    //       <View
    //         style={{
    //           marginTop: 10,
    //           marginBottom: 25,
    //           flexDirection: 'row',
    //           justifyContent: 'space-between',
    //           paddingHorizontal: 16,
    //         }}
    //       >
    //         <CustomButton
    //           text={'Previous'}
    //           color={'warn'}
    //           onPress={() =>
    //             navigation.navigate('NmInformationForm', {
    //               essUserOnBoardingFormKey,
    //               essUserOnBoardingKey,
    //               values,
    //               mode: "online"
    //             })
    //           }
    //         />
    //         <CustomButton
    //           isDisabled={!signatureDataURL || !hasDrawn}
    //           text={'Submit'}
    //           onPress={handlesubmit}
    //         />
    //       </View>
    //     )}
    //   </ScrollView>
    // </>

    <>
      <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
        <View style={[globalStyles.horizontalPadGap]}>
          <HomeDetailsHeader
            navLabel="Forms"
            navScreen="OnboardingForms"
            title={'NM Withholding Taxation'}
          />
        </View>
      </View>
      <SignatureFormView
        essUserOnBoardingFormKey={essUserOnBoardingFormKey}
        essUserOnBoardingKey={essUserOnBoardingKey}
        isSubmitting={loading}
        onPrevious={() =>
          navigation.navigate('NmInformationForm', {
            essUserOnBoardingFormKey,
            essUserOnBoardingKey,
            values,
            mode: "online",

          })
        }
        onSubmit={handlesubmit}
      />

    </>
  )
}


export default NmInformationOnline
